/**
 * Node Modules
 */
import React, { Fragment } from 'react'

/**
 * Application Modules
 */
import './style.css'

/**
 * Component
 */
export default function SectionHeading({ hed, dek }) {
  return (
    <Fragment>
      <h2 className="section-heading__hed column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
        {hed}
      </h2>
      <p className="section-heading__dek column-start-1 column-end-6 column-start-2--t column-end-11--t column-start-3--d column-end-10--d">
        {dek}
      </p>
    </Fragment>
  )
}
